export const getPluralFromEventType = (eventType) => {
    if (!eventType) {
        console.error("No event type");
        return "";
    }
    switch (eventType.trim().toLowerCase()) {
    case "activity":
        return "activities";
    case "class":
        return "classes";
    case "workshop":
        return "workshops";
    case "holiday camp":
        return "holiday camps";
    case "performance":
        return "performances";
    case "exhibition":
        return "exhibitions";
    case "event":
        return "events";
    default:
        console.error("No event type");
        return "";
    }
};
export default getPluralFromEventType;
